<wv-header *ngIf="notZinmeterRoute()"></wv-header>
<div class="content">
    <router-outlet></router-outlet>
    <wv-footer *ngIf="notZinmeterRoute()"></wv-footer>
</div>
